/**
 * The generic resource processor: a `.tres` or `.gdshader` file's text, or a binary resource's
 * bytes, through the FileEventBus into a `ParsedResource` (header type, ext/sub resources, raw
 * `[resource]` body) on the 'resource' bus slot. It is the one parse of a file: every slice that
 * decodes Godot text reads this slot's cache.
 */
import { createResourceProcessor } from '../createResourceProcessor';
import { GODOT_SHADER_EXTENSION } from '../../godot/project/resourceFormats';
import { parseShaderFile, parseTresFile } from '../../parser/parsedResource';
import { parseBinaryResource } from '../formats/binaryresource/parse';
import { fileExtension } from '../fileExtension';
export function createTresResourceProcessor(fileEventBus, eventBus) {
    return createResourceProcessor({
        fileEventBus,
        eventBus,
        resourceType: 'resource',
        // Every arrival, not `.tres` alone: a request this declines stays in flight, and a
        // peer waiting on it waits out its timeout. The parse fails other text at once.
        process: async (path, data) => {
            if (typeof data !== 'string')
                return parseBinaryResource(data);
            return fileExtension(path) === GODOT_SHADER_EXTENSION ? parseShaderFile(data) : parseTresFile(data);
        },
    });
}
//# sourceMappingURL=createTresResourceProcessor.js.map